import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import { usePageTracking } from './hooks/useAnalytics';
import Header from './components/Header';
import Footer from './components/Footer';
import Hreflang from './components/Hreflang';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Cases from './pages/Cases';
import CaseDetail from './pages/CaseDetail';
import Contact from './pages/Contact';
import Imprint from './pages/Imprint';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import './App.css';

function AppContent() {
  // Track page views on route changes
  usePageTracking();

  return (
    <div className="App">
      <Hreflang />
      <Header />
      <AnimatePresence mode="wait">
        <Routes>
          {/* English routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/cases" element={<Cases />} />
          <Route path="/cases/:slug" element={<CaseDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/imprint" element={<Imprint />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />

          {/* German routes */}
          <Route path="/de" element={<Home />} />
          <Route path="/de/wer-ist-pik" element={<About />} />
          <Route path="/de/was-wir-machen" element={<Services />} />
          <Route path="/de/projekte" element={<Cases />} />
          <Route path="/de/projekte/:slug" element={<CaseDetail />} />
          <Route path="/de/kontakt" element={<Contact />} />
          <Route path="/de/impressum" element={<Imprint />} />
          <Route path="/de/datenschutz" element={<Privacy />} />
          <Route path="/de/agb" element={<Terms />} />
        </Routes>
      </AnimatePresence>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <LanguageProvider>
          <AppContent />
        </LanguageProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
